import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPageAdd: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"page-add"} maskId="square-filled-radius-0-stroke-1-IconPageAdd"><path d="M4 2V22H17V20H14V17H17V14H20V2H4Z" fill="currentColor"/><path d="M19 18V15H18V18H15V19H18V22H19V19H22V18H19Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconPageAdd;
